import { Utils } from "../Utils/Utils";
import Control from "./Control";
import { SABISDynamicForm } from "../SABISDynamicForm";
import ProgressControl from "./ProgressControl";
export default class InputFileControl extends Control {
    constructor(field) {
        super(field);
        this.progressControl = new ProgressControl(field);
    }
    render() {
        var _a;
        let htmlFileList = "";
        if (this.initialValue) {
            this._value = this.initialValue;
            htmlFileList = this.getFileListHtml();
        }
        return (`<div data-main class="form-control file-control ${this.isPreviewMode() ? `preview` : ``}" id="${this.field.internalId}">` +
            (Utils.isOk(this.field.displayName)
                ? `<label>${this.field.displayName}`
                : "") +
            (this.isRequired() ? "<span class=required>*</span>" : "") +
            "</label>" +
            (Utils.isOk(this.field.hintAbove) && this.field.hintAbove !== ""
                ? `<span class=hint-above>${this.field.hintAbove}</span>`
                : "") +
            `<div class="form-control-container">
            ${!this.isPreviewMode()
                ? `<button class="add-file">Add File</button>${this.progressControl.render()}`
                : ``}
      <div class="file-list${htmlFileList ? ` visible` : ``}">${htmlFileList}</div>
      </div>
      ${Utils.isOk(this.field.hintBelow) && this.field.hintBelow !== ""
                ? `<span class=hint-below>${this.field.hintBelow}</span>`
                : ""}
      <input type=file ${((_a = this.field.fileFieldSettings) === null || _a === void 0 ? void 0 : _a.allowMultipleFiles) ? "multiple" : ""} />
      </div>`);
    }
    getRawValue() {
        return this._value && this._value.files.length > 0
            ? this._value.files[0].fileName
            : "";
    }
    getValue() {
        return this._value ? JSON.stringify(this._value) : "";
    }
    selectFiles() {
        this.fileField.click();
    }
    upload(form) {
        this.button.classList.add("hidden");
        this.progressControl.show();
        const fileSize = this.fileField.files[0].size;
        const progressCallback = (progressEvent) => {
            if (progressEvent.lengthComputable) {
                const percentComplete = (progressEvent.loaded / progressEvent.total) * 100 - 1;
                this.progressControl.update(percentComplete);
            }
        };
        const uploadCompleted = (data) => {
            this.progressControl.hide();
            this._value = {
                files: [
                    {
                        id: data.serverId,
                        fileName: data.filePath.split("\\").pop(),
                        fileSize: fileSize,
                        storagePath: data.filePath,
                        downloadUrl: data.downloadUrl,
                    },
                ],
            };
            this.showUploadedFiles();
        };
        const onUploadError = (error) => {
            this.progressControl.hide();
            this.fileList.classList.remove("visible");
            this.fileList.innerHTML = "";
            this.button.classList.remove("hidden");
            this._value = null;
            this.fileField.value = "";
            this.onChange();
        };
        // 1 function provided in the form options
        if (form.options.filesHandler) {
            form.options.filesHandler.uploadFile(this.fileField.files[0], progressCallback, uploadCompleted);
        }
        // 2 (default) internal function
        else {
            // call upload api
            if (!form.options.filesPath) {
                throw new Error("form.options.filesPath is required");
            }
            Utils.upload(`${form.options.apiUrl}/files`, `${form.options.filesPath}/${this.field.internalId}`, this.fileField, progressCallback, uploadCompleted, onUploadError).catch((error) => {
                onUploadError(error);
            });
        }
    }
    getFileListHtml() {
        var _a;
        let ret = ["<ul>"];
        (_a = this._value) === null || _a === void 0 ? void 0 : _a.files.forEach((f) => {
            let isImage = Utils.isImage(f.fileName);
            ret.push(`<li id=${f.id} ${isImage ? `class="image"` : ``}>
          <span><i class="fa-regular fa-file-text"></i>
            <a href="${f.downloadUrl}" target=_blank>
            ${isImage ? `<img src="${f.downloadUrl}">` : f.fileName}</a></span> 
            ${this.isPreviewMode()
                ? ""
                : `<button class="remove" data-id=${f.id}><i class="fa-regular fa-trash"></i> Remove uploaded file</button>`}
          </li>`);
        });
        ret.push("</ul>");
        return ret.join("");
    }
    showUploadedFiles() {
        var _a;
        if (!this.isPreviewMode()) {
            (_a = this.button) === null || _a === void 0 ? void 0 : _a.classList.add("hidden");
            this.fileList.innerHTML = this.getFileListHtml();
            this.fileList.classList.add("visible");
            //Give time to render
            setTimeout(() => {
                var _a;
                (_a = this._value) === null || _a === void 0 ? void 0 : _a.files.forEach((f) => {
                    document
                        .querySelector(`[data-id="${f.id}"`)
                        .addEventListener("click", this.removeFile);
                });
            }, 200);
            this.onChange();
        }
    }
    removeFile(ev) {
        ev.preventDefault();
        const formControl = Control.getFormControl(ev);
        const form = SABISDynamicForm.getForm(ev);
        const fileControl = (form.fields.find((f) => f.internalId === formControl.id).control);
        fileControl.fileList.classList.remove("visible");
        fileControl.fileList.innerHTML = "";
        fileControl.button.classList.remove("hidden");
        const fileId = ev.currentTarget.attributes.getNamedItem("data-id").value;
        fileControl._value = null;
        fileControl.fileField.value = "";
        fileControl.onChange();
    }
    submitFiles(ev) {
        const formControl = Control.getFormControl(ev);
        const form = SABISDynamicForm.getForm(ev);
        const fileControl = (form.fields.find((f) => f.internalId === formControl.id).control);
        fileControl.upload(form);
    }
    addFiles(ev) {
        ev.preventDefault();
        const formControl = Control.getFormControl(ev);
        if (formControl) {
            const form = SABISDynamicForm.getForm(ev);
            (form.fields.find((f) => f.internalId === formControl.id).control).selectFiles();
        }
    }
    afterRender() {
        if (!this.isPreviewMode()) {
            this.button = (document.querySelector(`[id="${this.field.internalId}"] button.add-file`));
            this.fileField = (document.querySelector(`[id="${this.field.internalId}"] input[type="file"]`));
            this.fileField.addEventListener("change", this.submitFiles);
            this.button.addEventListener("click", this.addFiles);
            this.fileList = (document.querySelector(`[id="${this.field.internalId}"] .file-list`));
        }
        if (this.initialValue) {
            this._value = this.initialValue;
            this.showUploadedFiles();
        }
    }
}
